<script>
import resources from './resources'

export default {
  name: 'auth-login',
  mixins: [resources]
}
</script>

<template lang="pug">
    .authentication
      .container
        .col-md-12.content-center
          .row
            .col-lg-6.col-md-12
              .company_detail
                h4.logo
                  img(src='/static/images/logo.svg', alt='')
                  br
                  span(style="font-size: 18px;") Condomum
                //-h3
                  strong Bem Vindo
                .footer
                  //-ul.social_link.list-unstyled
                    li
                      a(href='https://thememakker.com', title='ThemeMakker')
                        i.zmdi.zmdi-globe
                    li
                      a(href='https://themeforest.net/user/thememakker', title='Themeforest')
                        i.zmdi.zmdi-shield-check
                    li
                      a(href='https://www.linkedin.com/company/thememakker/', title='LinkedIn')
                        i.zmdi.zmdi-linkedin
                    li
                      a(href='https://www.facebook.com/thememakkerteam', title='Facebook')
                        i.zmdi.zmdi-facebook
                    li
                      a(href='http://twitter.com/thememakker', title='Twitter')
                        i.zmdi.zmdi-twitter
                    li
                      a(href='http://plus.google.com/+thememakker', title='Google plus')
                        i.zmdi.zmdi-google-plus
                    li
                      a(href='https://www.behance.net/thememakker', title='Behance')
                        i.zmdi.zmdi-behance
                  hr
                  //-ul
                    li
                      a(href='http://thememakker.com/contact/', target='_blank') Contato
                    li
                      a(href='http://thememakker.com/about/', target='_blank') Sobre
                    li
                      a(href='http://thememakker.com/services/', target='_blank') Serviços
                    li
                      a(href='javascript:void(0);') FAQ
            .col-lg-5.col-md-12.offset-lg-1
              .card-plain
                .header
                  h5 Acessar sua conta
                form.form
                  .input-group
                    input.form-control(
                      type='text',
                      placeholder='Email ou CPF',
                      v-model="credentials.email",
                      autofocus)

                    span.input-group-addon
                      i.zmdi.zmdi-account-circle
                  .input-group
                    input.form-control(
                      type='password',
                      placeholder='Senha',
                      v-model="credentials.password")

                    span.input-group-addon
                      i.zmdi.zmdi-lock

                  .checkbox
                      input(
                        type='checkbox'
                        v-model="credentials.remember"
                      )
                      label(for='terms', @click.prevent="remenberMe(credentials.remember)")
                        | Lembre-me

                  strong(style="color: #f96332;") {{ loginFail }}
                .footer
                  a.btn.btn-primary.btn-round.btn-block.btn-login(@click.prevent="doLogin()") LOGIN
                  router-link.btn.btn-primary.btn-simple.btn-round.btn-block(:to="{ name: 'register.dweller'}")  CADASTRO
                router-link.btn.btn-primary.btn-simple.btn-round.btn-block(:to="{ name: 'auth.forgot'}")
                  | Recuperar Senha
  </template>
<style scoped>
.checkbox-checked input[type="checkbox"]:checked+label::after {
    border-color: #7159c1;
    background: #7159c1;
    color: white;
}
.checkbox-checked label::after {
    font-family: 'Material-Design-Iconic-Font';
    content: "\f26b";
    top: 0px;
    text-align: center;
    font-size: 14px;
    opacity: 0;
    color: #555;
    border: 0;
    background-color: inherit;
        border-color: #7159c1;
    background: #7159c1;
    color: white;
}
  a:not([href]):not([tabindex]) {
      color: inherit;
      text-decoration: none;
      color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/app/auth/login/dweller/form.vue